class QuotationResultActionsComponent {
    /** @ngInject */
    constructor($state, DeviceChecker) {
        this.$state = $state
        this.isMobile = DeviceChecker.isMobile
    }

    goToVisitor() {
        this.onDispatch({ $event: { type: 'GO_TO_STATE_VISITOR' } })
    }

    goToResult() {
        this.onDispatch({ $event: { type: 'GO_TO_STATE_RESULT' } })
    }

    clickOnSubscribePlum() {
        this.onDispatch({ $event: { type: 'CLICK_ON_SUBSCRIBE_PLUM' } })
        this.$state.go('subscription')
    }
}

export default {
    template: require('./quotationResultActions.jade')(),
    controller: QuotationResultActionsComponent,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationResultActions.js